/** Tasks API calls (typed). */

import { apiDelete, apiGet, apiPatch, apiPost, type PaginatedResponse, type QueryParams } from "@/lib/api-client";
import type { ApiTask } from "./tasks.adapter";

export interface TasksListParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  assigneeId?: string;
  archived?: boolean;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export const tasksApi = {
  list: (params: TasksListParams = {}) =>
    apiGet<PaginatedResponse<ApiTask>>("/tasks", params as QueryParams),
  my: () => apiGet<PaginatedResponse<ApiTask>>("/tasks/my"),
  findById: (id: string) => apiGet<ApiTask>(`/tasks/${id}`),
  create: (body: Record<string, unknown>) => apiPost<ApiTask>("/tasks", body),
  update: (id: string, body: Record<string, unknown>) => apiPatch<ApiTask>(`/tasks/${id}`, body),
  archive: (id: string) => apiDelete<ApiTask>(`/tasks/${id}`),
  restore: (id: string) => apiPost<ApiTask>(`/tasks/${id}/restore`),
};
